import { getAccessToken, decodeJWTTokenPayload } from '@jutro/auth';
import { REQUEST_HANDLER_TYPE } from '../HttpRequestBuilder';
export const authTokenHandler = {
  [REQUEST_HANDLER_TYPE.AUTH]: async () => {
    const accessToken = await getAccessToken();
    return {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'GW-Tenant': decodeJWTTokenPayload(accessToken).tenant_id !== 'guidewire-hub' ? decodeJWTTokenPayload(accessToken).tenant_id : decodeJWTTokenPayload(accessToken).temp_tenant_id
      }
    };
  }
};